module.exports = __webpack_public_path__ + "img/cup_hover.a269f405.png";